import { createTheme, alpha } from '@mui/material';
import { colors, fonts, radii } from './brand/tokens';

const theme = createTheme({
  palette: {
    primary: {
      main: colors.orange,
      dark: colors.campari,
      light: alpha(colors.orange, 0.1),
      contrastText: colors.ice,
    },
    secondary: { main: colors.vermouth },
    text: {
      primary: colors.ink,
      secondary: alpha(colors.ink, 0.64),
    },
    background: { default: colors.peel, paper: colors.ice },
    divider: alpha(colors.ink, 0.1),
  },
  // MUI multiplies numeric sx borderRadius by this, so keep it at 4 (borderRadius: 4 => 16px).
  shape: { borderRadius: 4 },
  typography: {
    fontFamily: fonts.body,
    h1: { fontWeight: 800, letterSpacing: '-0.035em', lineHeight: 1.05 },
    h2: { fontWeight: 800, letterSpacing: '-0.03em', lineHeight: 1.1 },
    h3: { fontWeight: 700, letterSpacing: '-0.025em' },
    h4: { fontWeight: 700, letterSpacing: '-0.02em' },
    h5: { fontWeight: 700, letterSpacing: '-0.01em' },
    h6: { fontWeight: 700 },
    overline: { fontWeight: 700, letterSpacing: '0.12em' },
    button: { fontWeight: 600, textTransform: 'none' },
  },
  components: {
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: {
        root: { borderRadius: radii.pill, minHeight: 44 },
        sizeLarge: { minHeight: 52, fontSize: '1rem', paddingInline: 28 },
      },
    },
    MuiIconButton: {
      styleOverrides: { root: { minWidth: 44, minHeight: 44 } },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: radii.md,
          backgroundColor: colors.ice,
          // 16px minimum stops iOS Safari from zooming into focused inputs.
          fontSize: 16,
        },
      },
    },
    MuiInputLabel: { styleOverrides: { root: { fontSize: 16 } } },
    MuiChip: { styleOverrides: { root: { fontWeight: 600 } } },
    MuiDialog: {
      styleOverrides: { paper: { borderRadius: radii.lg } },
    },
    MuiSnackbar: {
      styleOverrides: {
        root: { top: 'calc(var(--safe-top) + 16px) !important' },
      },
    },
  },
});

export default theme;
